import { IS_APP_BUILD } from './appBrand';
import { safeNext } from './guestMode';

/**
 * Вход с возвратом туда, откуда выбросило (26.09.2026, техдолг 299).
 *
 * ⚠️ ЗАЧЕМ. Сессия кончилась посреди урока — ученик попадал на `/login`, а после входа на главную, и урок
 * приходилось искать заново. Теперь путь урока едет в `?next=`: переживает перезагрузку страницы
 * (`api/client.ts`, logoutAndReload), а состояние перехода её не переживает.
 *
 * Куда можно вернуть — решает тот же `safeNext`, что у гостевого режима: только `/app/…`, без чужих
 * адресов и выходов из кабинета. Сотрудника ведём в свой кабинет всегда — это решают экраны входа.
 */

/** Экраны входа и восстановления: сюда не возвращают, и отсюда не перезагружают на вход. */
const AUTH_SCREENS = [
  '/login',
  '/login-code',
  '/enter-code',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
];

export function isAuthScreen(pathname: string): boolean {
  return AUTH_SCREENS.includes(pathname.replace(/\/+$/, '') || '/');
}

/**
 * Выход КНОПКОЙ — не «выбросило» (27.09.2026, сборка 61).
 *
 * ⚠️ ДЕФЕКТ, ИЗ-ЗА КОТОРОГО ЭТО ЕСТЬ. «Выйти» в настройках приложения стирало сеанс, пока открыт
 * `/app/profile/settings`; защита маршрутов (`RequireAuth`) видела «сеанса нет» и уводила на
 * `/login?next=/app/profile/settings` — механизм возврата после истёкшей сессии. Следующий вход (другой
 * человек, ревьюер) попадал в чужие настройки. Возврат нужен, когда сессию отняли, а не когда человек вышел сам.
 *
 * Поэтому каждое место, где человек выходит сам (кнопка «Выйти», удаление профиля, «Войти паролем» на экране
 * Face ID), зовёт `markUserLogout()` перед `logout()`; до следующего входа (`clearUserLogout` в `setAuth`) экран
 * входа открывается без `?next`. Выход по истёкшей сессии (`api/client.ts`) метку не ставит — возврат цел.
 * Сторож — `loginLanding.test.ts`.
 */
let userLogout = false;
export function markUserLogout(): void {
  userLogout = true;
}
export function clearUserLogout(): void {
  userLogout = false;
}

/** Адрес экрана входа с возвратом на `path` (путь и строка запроса), если туда можно вернуть. */
export function loginPathWithNext(path: string): string {
  if (userLogout) return '/login';
  const next = safeNext(path);
  return next ? `/login?next=${encodeURIComponent(next)}` : '/login';
}

/**
 * Куда вести ученика после входа, если возврата нет (27.09.2026, решение владельца): в приложении —
 * «Обучение» (`/app/lessons`), на сайте — главная кабинета, как было.
 */
export function studentLanding(app: boolean = IS_APP_BUILD): string {
  return app ? '/app/lessons' : '/app';
}

/** Возврат из строки запроса экрана входа (`?next=…`), проверенный `safeNext`. */
export function nextFromSearch(search: string): string | null {
  try {
    return safeNext(new URLSearchParams(search).get('next'));
  } catch {
    return null;
  }
}
